<template>
  <div class="usermanagetable">
    <el-table :data="tableData" style="width: 100%;padding:10px 10px 0 10px;"  border>
      <el-table-column prop="activityName" show-overflow-tooltip label="活动名"></el-table-column>
      <el-table-column prop="title" show-overflow-tooltip label="筛选任务标题"></el-table-column>
      
      <el-table-column prop="status" label="状态" width="90">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 0">
            <el-tag type="info">{{'未开始'}}</el-tag>
          </div>

          <div v-if="scope.row.status === 1">
            <el-tag type="success">{{'初选中'}}</el-tag>
          </div>

          <div v-if="scope.row.status === 2">
            <el-tag>{{'复审中'}}</el-tag>
          </div>

          <div v-if="scope.row.status === 3">
            <el-tag type="danger">{{'已结束'}}</el-tag>
          </div>
          <!-- <span
            :style="{'color':scope.row.status === 1 ? 'red' : '#606266'}"
          >{{scope.row.status === 0 ? '开启' : '停用'}}</span> -->
        </template>
      </el-table-column>

      <el-table-column prop="createUserName" label="创建人"></el-table-column>

      <el-table-column prop="currentUsername" label="当前操作人"></el-table-column>

      <el-table-column label="操作" width="350">
        <template slot-scope="scope">
          
          <el-button v-if="scope.row.status === 0 || scope.row.status === 1" @click="firstClick(scope)" style="color:#F96900;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-document-checked"></i>初选</el-button>
          <el-button v-if="scope.row.status === 2 && powersObj.checkPictureArticleFilter && createUid === scope.row.currentUid" @click="reviewClick(scope)" style="color:#cc0033;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-folder-checked"></i>复审</el-button>
          <span v-if="scope.row.status === 1 || scope.row.status === 2 && powersObj.checkPictureArticleFilter && createUid === scope.row.currentUid" style="margin:0 11px;">|</span>
          <el-button v-if="scope.row.status === 1 || scope.row.status === 2 && createUid === scope.row.currentUid" @click="giveClick(scope)"  style="color:#47bd38;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-sell"></i>送审</el-button>
          <span v-if="scope.row.status === 2 && powersObj.checkPictureArticleFilter && createUid === scope.row.currentUid" style="margin:0 11px;">|</span>
          <el-button v-if="scope.row.status === 2 && powersObj.checkPictureArticleFilter && createUid === scope.row.currentUid" @click="endClick(scope)" style="color:#185ED3;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-circle-close"></i>结束</el-button>
          <span v-if="scope.row.status === 2 && powersObj.checkPictureArticleFilter && createUid !== scope.row.currentUid">暂无</span>
          <el-button v-if="scope.row.status === 3" @click="downloadClick(scope)" style="color:#185ED3;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-circle-check"></i>查看结果</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// import {userTabletype,userTablemode} from '@/constants/tablecommon'
import { mapGetters } from "vuex";
import { listAuthRole } from "@/api/authRole";
import { powersObj } from "@/constants/powers";
export default {
  name: "usermanagetable",
  props: {
    tableData: Array
  },
  computed: {
    ...mapGetters(["createUid"])
  },
  data() {
    return {
      powersObj
      // userTabletype,
      // userTablemode,
      // tableData:[
        // {
        //   createMy:'2020-06-22',
        //   name:'默认主题-红色',
        //   moblie:'default-red',
        //   status:0
        // },
        // {
        //   createMy:'2020-06-22',
        //   name:'默认主题-黑色',
        //   moblie:'default-black',
        //   status:1
        // },{
        //   createMy:'2020-06-22',
        //   name:'默认主题-蓝色',
        //   moblie:'default-blue',
        //   status:0
        // },
      // ]
    };
  },
  methods: {
    firstClick(scope) {
      this.$emit("firstClick", scope);
    },
    giveClick(scope) {
      this.$emit("giveClick", scope);
    },
    endClick(scope) {
      this.$emit("endClick", scope);
    },
    reviewClick(scope) {
      this.$emit("reviewClick", scope);
    },
    downloadClick(scope) {
      this.$emit("downloadClick", scope);
    },

  },
  created() {
    // this.listAuthRoleAsync()
    
  },
  mounted(){
    // console.log(this.tableData)
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  width: auto;
}
.active {
  color: red;
}
.btn:hover{
  text-decoration: underline;
}
</style>
